var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMindfulness = function SvgMindfulness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M44 8.25a10.08 10.08 0 0 0-5.77 18.35 17.42 17.42 0 0 0-13.7 7.8l-3.54 5.36L7.83 47.1l2.68 4.8 13.75-7.66c.38-.22.7-.52.95-.9l3.9-5.9a11.92 11.92 0 0 1 9.95-5.36h9.88c4 0 7.74 2.01 9.95 5.36l3.9 5.9c.24.38.57.68.95.9L77.5 51.9l2.68-4.8-13.16-7.34-3.53-5.35a17.42 17.42 0 0 0-13.7-7.8 10.07 10.07 0 0 0 4.3-8.28c0-5.56-4.51-10.08-10.08-10.08Zm-4.58 10.08a4.58 4.58 0 1 1 9.16 0 4.58 4.58 0 0 1-9.16 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M38.78 79.23a9.13 9.13 0 0 0 5.66 1.17 9.13 9.13 0 0 0 4.14-1.22l18.91-10.92a9.17 9.17 0 0 0-9.17-15.88l-1.49.86V44h-5.5v12.42l-7.7 4.44-6.96-4.02V44h-5.5v9.67l-2.48-1.43a9.17 9.17 0 0 0-9.16 15.88l19.25 11.11Zm-3.93-8.62-12.57-7.26A3.67 3.67 0 0 1 25.94 57l12.3 7.1a9.17 9.17 0 0 0-3.4 6.51Zm26.22-13.47a3.67 3.67 0 1 1 3.67 6.35L45.83 74.42a3.67 3.67 0 0 1-3.67-6.35l18.91-10.92Z",
    clipRule: "evenodd"
  })));
};
export default SvgMindfulness;